import helpers from '../helpers.js';

/**
 * @ngdoc service
 * @name BaseClass.BCAPIMessages
 * @description
 *
 * Model extension that broadcasts messages on $http responses. Define your UIMessages feedback on the model.
 * Each time a model saved, broadcast a message.
 */
export default angular.module('BaseClass.APIMessages',[])
    .factory('BCAPIMessages', function($rootScope) {
        function APIMessages() {
        /**
         * @ngdoc property
         * @name BaseClass.BCAPIMessages#apiMessages
         * @propertyOf BaseClass.BCAPIMessages
         * @description Object containing the configured messages It's structure is flexible, trying to find
         * a match from most to least specific
         *
         * <pre>
         * {
         *      'POST /users': {
         *          200: 'User created',
         *          406: 'User invalid'
         *      },
         *      '/users/:guid': { // URL params are matched with `\/\:[^\/]+`
         *          404: 'User not found',
         *          401: 'Not authorized to view users'
         *      },
         *      'DELETE': {
         *          200: 'common.notice.deleted'
         *      },
         *      default: {
         *          500: 'common.notice.serverError' // Translations are supported
         *      }
         * }
         * </pre>
         */
            this.apiMessages = {
                'POST': {
                    200: 'common.notice.saved'
                },
                'PUT': {
                    200: 'common.notice.saved'
                },
                'DELETE': {
                    200: 'common.notice.deleted'
                },
                default: {
                    403: 'common.notice.unauthorized',
                    404: 'common.notice.notFound',
                    406: 'common.notice.invalid',
                    500: 'common.notice.serverError'
                }
            };

            /**
         * @ngdoc method
         * @name BaseClass.BCAPIMessages#configureAPIMessages
         * @methodOf BaseClass.BCAPIMessages
         * @description Add API messages
         *
         * @param {Object} errorConfig One or more endpoints with statuscodes and accompanying messages
         * <pre>
         * {
         *      '/ticket/:guid/products/:pguid/attach': {
         *          500: 'Error attaching product'
         *      }
         * }
         * </pre>
         */
            this.configureAPIMessages = function(errorConfig) {
                let paramRegex = /\/\:[^\/]+/g;
                _.forEach(errorConfig, function(codes, url) {
                    if(url === 'default') return;
                    let urlMatcher = url;
                    let p = paramRegex.exec(url);
                    while(p !== null) {
                        urlMatcher = urlMatcher.replace(p[0], '\/[^\/]*');
                        p = paramRegex.exec(url);
                    }
                    if(urlMatcher !== url)
                        codes.match = new RegExp('^' + urlMatcher + '$', 'i');
                });
                _.assign(this.apiMessages, errorConfig);
            };

            /**
         * @ngdoc method
         * @name BaseClass.BCAPIMessages#broadcastAPIMessage
         * @methodOf BaseClass.BCAPIMessages
         * @description Broadcast an APIMessage.
         * It searches for a configured API message by specificity, starting at `method + url`, `url`,
         * `method` and finally `default`.
         * This method is available on both class and instance level
         * @eventType broadcast
         *
         * @param {Object} response A $http response object
         * @emits APIMessage
         */
            this.broadcastAPIMessage = function(response) {
                if(!response || !response.config)
                    return;
                let url = response.config.url;
                url = stripRoot(url);
                let method = response.config.method.toUpperCase();
                let status = response.status;
                let specificity = [
                    method + ' ' + url,
                    url,
                    method,
                    'default'
                ];
                let message = null;

                for ( let i = 0; i < 4; i++ ) {
                    let s = specificity[i];
                    let match = _.find(this.apiMessages, (obj, path) => {
                        if(obj.match)
                            return obj.match.test(s);
                        return path === s;
                    });
                    if(match && match[status]) {
                        message = match[status];
                        break;
                    }
                }

                if(message)
                    $rootScope.$broadcast('APIMessage', status, message);
            };

            var roots = {
                shop: (SHOP_API_ROOT).replace(/^(https?:)?\/\//, ''),
                order: (ORDER_API_ROOT).replace(/^(https?:)?\/\//, ''),
                dashboard: (DASHBOARD_API_ROOT).replace(/^(https?:)?\/\//, '')
            };

            function stripRoot(url) {
                url = url.replace(/^(https?:)?\/\//, '');
                _.find(roots, root => {
                    if(url.indexOf(root) === 0) {
                        url = url.replace(root, '');
                        return true;
                    }
                    return false;
                });
                return url;
            }

            Object.defineProperties(this, {
                __broadcastAPIMessage: {
                    value: function(response) {
                        this.constructor.broadcastAPIMessage(response);
                    },
                    enumerable: false
                }
            });
        }
        return APIMessages;
    }).name;
